import { DEFAULTS } from "./defaults.js";
import { LINK_PREVIEW_TYPE } from "./types.js";
import { nodeViewRenderers } from "./viewer/loadable/node-view-renderers-loadable.js";
const pluginLinkPreview = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: LINK_PREVIEW_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginLinkPreview
};
//# sourceMappingURL=viewer-loadable.js.map
